var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row py-3"},_vm._l((30),function(index){return _c('div',{staticClass:"col-4"},[_c('div',{staticClass:"juz",on:{"click":function($event){return _vm.redirectToFristJuzaPage(index)}}},[_vm._v("الجزء "+_vm._s(index))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }